import * as React from 'react';

import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { CardDisplayFilterItem } from 'components/search/sort-filter';
import { FlightsCardsDisplayFilterOptionType } from 'types/search/sort-filter';
import { FlightsFilterItemType, FlightsCardDisplayFilterItemType } from 'types/shared';
import { FILTER_TYPE_TO_ID_PREFIX } from 'utility/filter-constants';

interface CardDisplayFilterGroupProps {
  keySuffix: string;
  filterOption: FlightsCardsDisplayFilterOptionType;
  updateFilter: (keySuffix: string) => void;
}

const renderDisplayFilterItems = (
  items: FlightsFilterItemType[],
  type: string,
  keySuffix: string,
  updateFilter: (keySuffix: string) => void
) =>
  items.map((filterItem: FlightsCardDisplayFilterItemType, key) => {
    const idPrefix = FILTER_TYPE_TO_ID_PREFIX[type];

    return (
      <UitkLayoutGridItem key={`${idPrefix}-${key}`}>
        <CardDisplayFilterItem
          filterItem={filterItem}
          keySuffix={keySuffix}
          idPrefix={idPrefix}
          updateFilter={updateFilter}
        />
      </UitkLayoutGridItem>
    );
  });

export const CardDisplayFilterGroup = ({ filterOption, keySuffix, updateFilter }: CardDisplayFilterGroupProps) => {
  const { label, items, type } = filterOption;

  return (
    <fieldset className="all-b-margin-six">
      <legend className="uitk-type-heading-300 all-b-margin-four">{label}</legend>
      <UitkLayoutGrid columns={2} space="two">
        <>{renderDisplayFilterItems(items, type, keySuffix, updateFilter)}</>
      </UitkLayoutGrid>
    </fieldset>
  );
};
